import Clarity from '@microsoft/clarity'
import { config } from 'config'

export const initClarity = () => {
  const projectId = config.CLARITY_PROJECT_ID

  if (projectId) {
    Clarity.init(projectId)
  }
}
